<div class="container" fxLayout="column" fxLayoutAlign="center center">
  <h1 mat-dialog-title>Are you sure?</h1>
  <div mat-dialog-content>
    <p>There could be Legal implications</p>
    <p *ngIf="!data.request">We will email {{ data.partnerName }} to notify them you have terminated the partnership.</p>
    <p *ngIf="data.request">We will email {{ data.partnerName }} to notify them of your request to partner with them.</p>
  </div>
  <div mat-dialog-actions fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px">
    <button *ngIf="!data.request" mat-flat-button color="warn" [mat-dialog-close]="true" cdkFocusInitial>
      <mat-icon>link_off</mat-icon> Terminate
    </button>
    <button *ngIf="data.request" mat-flat-button color="accent" [mat-dialog-close]="true" cdkFocusInitial>
      <mat-icon>add_link</mat-icon> Send Request
    </button>
    <button mat-stroked-button color="basic" (click)="cancelClick()">
      <mat-icon>clear</mat-icon> Cancel
    </button>
  </div>
</div>